module.exports = __webpack_public_path__ + "static/media/6.96e1ca8c.jpg";